import { withSnackbar } from "../../../components/atoms/SpSnackBar";
import React from "react";
import PatientsReportsTrainingMatchInjury from "./PatientsReportsTrainingMatchInjury";
const PatientsReportsStep12MatchInjury = (props) => {
  return <PatientsReportsTrainingMatchInjury type={"match"} />;
};

export default withSnackbar(PatientsReportsStep12MatchInjury);
